<template>
  <v-alert
    text
    color="#BF0000"
    type="error"
    class="top-spaced-item multi-line custom-alert pb-0 pl-14 mb-8"
    :icon="false"
  >
    <p>
      Special characters may cause issues. Use letters (a–z) and numbers (0–9) for best results.
    </p>
  </v-alert>
</template>

<script>
export default {};
</script>
